export default "__VITE_ASSET__Cik8ua9I__"